import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiHome, FiList, FiMail, FiFilter } from 'react-icons/fi';
import eventEmitter from '../services/eventEmitter';

const MobileNav = ({ onContactClick }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isListingDetailPage = location.pathname.startsWith('/listings/');

  const homeOrFilterItem = isHomePage
    ? { action: () => eventEmitter.dispatch('openFilterSheet'), label: 'Filter', icon: <FiFilter size={22} />, isFilter: true }
    : { path: '/', label: 'Home', icon: <FiHome size={22} /> };

  let navItems = [
    homeOrFilterItem,
    { path: '/#all-listings', label: 'Listings', icon: <FiList size={22} /> },
    { action: onContactClick, label: 'Contact Us', icon: <FiMail size={22} /> },
  ];

  // Conditionally remove the "Listings" button on the listing detail page
  if (isListingDetailPage) {
    navItems = navItems.filter(item => item.label !== 'Listings');
  }

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 w-full z-40 bg-white border-t border-zinc-200 shadow-t-lg">
      <nav className="flex justify-around items-center h-16">
        {navItems.map((item, index) => {
          // The home/filter/back button is always a button now if it has an action
          if (item.action) {
            return (
              <button
                key={index}
                onClick={item.action}
                className={`flex flex-col items-center justify-center text-center transition-colors w-20
                  ${item.isFilter ? 'text-indigo-600 font-semibold' : 'text-zinc-600 hover:text-indigo-600'}`
                }
              >
                {item.icon}
                <span className="text-xs mt-1">{item.label}</span>
              </button>
            );
          }

          // Handle anchor vs. regular links
          const isActive = item.path ? location.pathname === item.path.split('#')[0] : false;
          if (item.path.includes('#')) {
             return (
              <a
                key={index}
                href={item.path}
                className={`flex flex-col items-center justify-center text-center transition-colors w-20 ${isActive ? 'text-indigo-600' : 'text-zinc-600 hover:text-indigo-600'}`}
              >
                {item.icon}
                <span className="text-xs mt-1">{item.label}</span>
              </a>
             )
          }

          return (
            <Link
              key={index}
              to={item.path}
              className={`flex flex-col items-center justify-center text-center transition-colors w-20 ${isActive ? 'text-indigo-600' : 'text-zinc-600 hover:text-indigo-600'}`}
            >
              {item.icon}
              <span className="text-xs mt-1">{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default MobileNav;
